import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import SidebarAd from './components/SidebarAd';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import NewsRoom from './pages/NewsRoom';
import Academy from './pages/Academy';
import Theater from './pages/Theater';
import Donate from './pages/Donate';
import Testimonials from './pages/Testimonials';
import Faculty from './pages/Faculty';
import Scholarships from './pages/Scholarships';
import Classes from './pages/Classes';

import PhotoGallery from './pages/PhotoGallery';
import RepertoireReviews from './pages/RepertoireReviews';
import MeetTheBoard from './pages/MeetTheBoard';
import RehearsalSchedule from './pages/RehearsalSchedule';
import CastingRequirements from './pages/CastingRequirements';
import ArticlePage from './pages/ArticlePage';

const AdBanner = () => (
  <div className="flex justify-center my-4">
    <iframe
      border="0"
      src="https://www.trip.com/partners/ad/SB5666663?Allianceid=6648580&SID=228113005&trip_sub1="
      style={{ width: '468px', height: '60px' }}
      frameBorder="0"
      scrolling="no"
      id="SB5666663"
    ></iframe>
  </div>
);

const PageWithAds = ({children}) => (
    <>
        <AdBanner />
        {children}
        <AdBanner />
        <AdBanner />
    </>
)

const LayoutWithSidebar = ({ children }) => (
  <div className="flex flex-1 min-h-screen">
    <SidebarAd />
    <main className="flex-1">
      {children}
    </main>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-ballet-light">
        <Header />
        <LayoutWithSidebar>
          <Routes>
            <Route path="/" element={<PageWithAds><Home /></PageWithAds>} />
            <Route path="/contact-us" element={<PageWithAds><ContactUs /></PageWithAds>} />
            <Route path="/news-room" element={<PageWithAds><NewsRoom /></PageWithAds>} />
            <Route path="/news/:title" element={<PageWithAds><ArticlePage /></PageWithAds>} />
            <Route path="/academy" element={<PageWithAds><Academy /></PageWithAds>} />
            <Route path="/theater" element={<PageWithAds><Theater /></PageWithAds>} />
            <Route path="/donate" element={<PageWithAds><Donate /></PageWithAds>} />
            <Route path="/testimonials" element={<PageWithAds><Testimonials /></PageWithAds>} />
            <Route path="/faculty" element={<PageWithAds><Faculty /></PageWithAds>} />
            <Route path="/scholarships" element={<PageWithAds><Scholarships /></PageWithAds>} />
            <Route path="/classes" element={<PageWithAds><Classes /></PageWithAds>} />

            <Route path="/photo-gallery" element={<PageWithAds><PhotoGallery /></PageWithAds>} />
            <Route path="/repertoire-reviews" element={<PageWithAds><RepertoireReviews /></PageWithAds>} />
            <Route path="/meet-the-board" element={<PageWithAds><MeetTheBoard /></PageWithAds>} />
            <Route path="/rehearsal-schedule" element={<PageWithAds><RehearsalSchedule /></PageWithAds>} />
            <Route path="/casting-requirements" element={<PageWithAds><CastingRequirements /></PageWithAds>} />
          </Routes>
        </LayoutWithSidebar>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
